import React from 'react';
import { RestaurantCard } from './RestaurantCard';
import { motion } from 'framer-motion';
const RESTAURANTS = [{
  name: 'Grilled 211',
  url: 'https://grilled211paducahky.com',
  address: 'Paducah, KY',
  description: 'A premier American grill offering perfectly seared steaks, fresh seafood, and classic comfort food in a refined yet welcoming atmosphere.',
  menuItems: ['Signature Ribeye Steak', 'Grilled Atlantic Salmon', 'Classic 211 Burger', 'Loaded Baked Potato Soup'],
  image: 'https://images.unsplash.com/photo-1544025162-d76694265947?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
}, {
  name: "Freddy Cheah's",
  url: 'https://freddycheah.com',
  address: 'Paducah, KY',
  description: 'Our signature family restaurant bringing together generations of culinary expertise with a diverse menu that has something for everyone.',
  menuItems: ["Chef Freddie's Special Pasta", 'Herb-Roasted Half Chicken', 'Signature House Salad', 'Warm Chocolate Lava Cake'],
  image: 'https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
}, {
  name: 'Pizza Warehouse',
  url: 'https://pizzawarehousepaducahky.com',
  address: 'Paducah, KY',
  description: 'Authentic, hand-tossed pizzas made with fresh, locally sourced ingredients and baked to perfection in our custom ovens.',
  menuItems: ['The Warehouse Supreme Pie', 'Classic Margherita', 'Garlic Parmesan Knots', "Meat Lover's Deep Dish"],
  image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'
}];
export function RestaurantShowcase() {
  return <section className="py-32 px-6 md:px-12 bg-neutral-950" id="restaurants" data-id="element-84">
      <div className="max-w-7xl mx-auto" data-id="element-85">
        <motion.div className="text-center mb-24" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-86">
          <h2 className="text-sm font-medium text-amber-500 uppercase tracking-[0.3em] mb-6" data-id="element-87">
            Our Portfolio
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-stone-50 mb-8" data-id="element-88">
            Culinary Excellence
          </h3>
          <div className="w-px h-12 bg-neutral-800 mx-auto" data-id="element-89"></div>
        </motion.div>

        <div className="flex flex-col" data-id="element-90">
          {RESTAURANTS.map((restaurant, index) => <RestaurantCard key={index} {...restaurant} index={index} data-id="element-91" />)}
        </div>
      </div>
    </section>;
}